import { translate, translateFormatter } from '@/domains/core/localization/translate';
const {
  basedOn,
  currentlyViewed
} = translate({
  "basedOn": "Based on",
  "currentlyViewed": "Currently viewed"
});
const customersTopProducts = translateFormatter<{
  numOfProducts: number;
}>("Our customers' Top {numOfProducts} products", undefined, undefined, "en");
export { basedOn, currentlyViewed, customersTopProducts };